import * as React from 'react'
import { SVGProps } from 'react'

const SvgUsdtPolygonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 49 48' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx={24} cy={24} r={24} fill='#4D9E7D' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.245 26.298c-.126.01-.774.05-2.22.05a46.39 46.39 0 0 1-2.252-.05c-4.443-.205-7.76-1.016-7.76-1.987 0-.97 3.317-1.78 7.76-1.988v3.167c.29.022 1.123.074 2.273.074 1.38 0 2.07-.06 2.195-.073v-3.166c4.433.207 7.743 1.018 7.743 1.986 0 .969-3.309 1.78-7.744 1.986h.005Zm0-4.3v-2.835h6.187v-4.321H15.585v4.321h6.187v2.834c-5.028.242-8.81 1.286-8.81 2.537 0 1.25 3.782 2.294 8.81 2.537v9.082h4.472v-9.085c5.017-.242 8.792-1.285 8.792-2.535 0-1.25-3.772-2.293-8.792-2.537v.002Z'
      fill='#fff'
    />
    <circle r={8.5} transform='matrix(1 0 0 -1 40.5 11.5)' fill='#8247E5' />
    <path
      d='M42.781 13.193a.593.593 0 0 1-.556 0l-1.296-.76-.88-.483-1.274-.76a.593.593 0 0 0-.556 0l-.996.598a.56.56 0 0 0-.278.484v1.152c0 .184.093.368.278.483l.996.576c.162.092.37.092.556 0l.996-.599a.56.56 0 0 0 .278-.484v-.76l.88.507v.783a.567.567 0 0 1-.278.484l-1.853 1.082a.593.593 0 0 1-.556 0l-1.899-1.105a.506.506 0 0 1-.278-.46v-2.166c0-.184.093-.368.278-.483l1.876-1.083a.593.593 0 0 1 .556 0l1.274.737.88.507 1.273.737c.162.092.37.092.556 0l.996-.576a.56.56 0 0 0 .278-.483V9.969a.567.567 0 0 0-.278-.484l-.973-.575a.593.593 0 0 0-.556 0l-.995.575a.56.56 0 0 0-.278.484v.737l-.88-.507v-.76c0-.184.092-.368.278-.483l1.875-1.083a.593.593 0 0 1 .556 0l1.876 1.083a.56.56 0 0 1 .278.483v2.188a.567.567 0 0 1-.278.484l-1.876 1.082Z'
      fill='#F0F0F0'
    />
  </svg>
)

export default SvgUsdtPolygonIcon
